import React, { useState } from "react";
import styles from "./PasswordInput.module.css";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const PasswordInput = ({ value, onChange, placeholder, name, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={styles.passwordWrapper}>
      <input
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        className={styles.input}
        {...rest}
      />
      <button
        type="button"
        className={styles.toggleButton}
        onClick={() => setShowPassword(!showPassword)}
        tabIndex={-1} // éviter focus via Tab
      >
        {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
      </button>
    </div>
  );
};

export default PasswordInput;
